import dayjs from 'dayjs';
import Button from 'partial/components/Button';
import Table from 'partial/components/Table';
import React from 'react';
import { BsPencil, BsTrash } from 'react-icons/bs';
import { useParams } from 'react-router-dom';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import { AiOutlinePlus } from 'react-icons/ai';
import cn from 'classnames';
import { useDomainList } from '../hooks';
import { useOpenDomainSetup } from '../modals/DomainSetup';
import { useOpenRemoveDomain } from '../modals/RemoveDomain';

function Domain() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const orgUuid = subscriber?.organization?.uuid;
  const [isLoading, list] = useDomainList(orgUuid);
  const openDomain = useOpenDomainSetup();
  const openRemove = useOpenRemoveDomain();

  const format = [
    {
      label: 'date',
      id: 'date',
      key: (item) => (
        <span>{dayjs(item?.created_at).format('MMM DD, YYYY hh:mm A')}</span>
      ),
    },
    {
      label: 'domain',
      id: 'domain',
      key: 'domain',
    },
    {
      label: 'remarks',
      id: 'remarks',
      key: 'remarks',
    },
    {
      id: 'with_subdomain',
      label: 'Subdomain',
      key: (item) => (
        <div
          className={cn(
            'text-xs font-semibold rounded-[3px] tracking-wider text-center py-[2px] px-[14px] text-white',
            item?.with_subdomain ? 'bg-success' : 'bg-danger',
          )}
        >
          {item?.with_subdomain ? 'YES' : 'NO'}
        </div>
      ),
    },
    {
      id: 'action',
      label: 'actions',
      key: (item) => (
        <div className="flex gap-2">
          <Button
            icon={BsPencil}
            outline
            size="xs"
            className="font-bold tracking-widest"
            onClick={() =>
              openDomain({
                organization: subscriber?.organization,
                type: 'edit',
                domain: item,
              })
            }
          >
            Edit
          </Button>
          <Button
            icon={BsTrash}
            outline
            size="xs"
            className="font-bold tracking-widest"
            onClick={() =>
              openRemove({
                org: subscriber?.organization?.uuid,
                domain: item?.uuid,
                name: item?.domain,
              })
            }
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-2">
      <div className="flex justify-end">
        <Button
          icon={AiOutlinePlus}
          size="xs"
          primary
          className="w-[150px] uppercase"
          onClick={() =>
            openDomain({ organization: subscriber?.organization, type: 'add' })
          }
        >
          Add Domain
        </Button>
      </div>
      <div className="h-full flex flex-col space-y-10 justify-between">
        <Table data={list} format={format} isLoading={isLoading} />
        {/* <div className="px-3">
        <Pagination value={meta} onChange={setFilter} />
      </div> */}
      </div>
    </div>
  );
}

export default Domain;
